
import React, {
  PropTypes
} from 'react';

import {
  Grid, Row, Col
} from 'react-bootstrap';

import intro from './intro';
import SocialMedia from './SocialMedia';
import NextSectionButton from '../common/NextSectionButton';

import env from '../../lib/env';

import './index.css';

// ... this whole mess...
//     Because of GitHub Pages path...
//     GitHub Pages => /portfolio/images...
//     localhost/dev => /images...
//     We manually change the path here if we're in dev env.
if (env.isDevelopment()) {
  const styleSheets = document.styleSheets;
  const devRule = 'url("/images/intro/intro-bg.jpg")';

  let ix;
  let ixix;
  let rules;
  let rule;
  let style;

  for (ix = 0; ix < styleSheets.length; ix++) {
    rules = styleSheets[ix].cssRules;
    for (ixix = 0; ixix < rules.length; ixix++) {
      rule = rules[ixix];
      if (rule.selectorText && rule.selectorText === '#intro::before') {
        style = rule.style;
        style.background = devRule;
        style.backgroundImage = devRule;
        style.backgroundRepeat = 'no-repeat';
        style.backgroundSize = 'cover';
      }
    }
  }
}

const Intro = ({ appData }) => (
  <div>
    <Grid id="intro">
      <Row>
        <Col md={12} className="intro-body">
          <h3 className="brand-heading">{intro.brandHeadingText(appData.devName)}</h3>

          <div className="intro-text">
            <p className="slogan"><i>{intro.slogan}</i></p>
            <div className="contact">
              {/* <p>{appData.contact.phone}</p> */}

              <p><a href={ `mailto:${appData.contact.email}` }>{appData.contact.email}</a></p>

              <ul className="list-inline">
                {
                  appData.socialMedia.map((socialMedia) => (
                    <li key={socialMedia.name}>
                      <SocialMedia socialMedia={socialMedia} />
                    </li>
                  ))
                }
              </ul>
            </div>
          </div>

          <hr />

          <NextSectionButton
            targetID="contact"
            className=""
            bsStyle="primary"
            bsSize="large"
          >
            I need your help
          </NextSectionButton>

          <hr style={{ visibility: 'hidden' }} />

          <NextSectionButton
            targetID="services"
            className=""
            bsStyle="info"
            bsSize="large"
          >
            I'd like to learn more
          </NextSectionButton>
        </Col>
      </Row>
    </Grid>
  </div>
);

Intro.propTypes = {
  appData: PropTypes.shape().isRequired
};

export default Intro;



// WEBPACK FOOTER //
// ./src/components/intro/index.js